module.exports = __webpack_public_path__ + "img/print_template_avatar.a8c41a94.svg";